export default __webpack_public_path__ + "static/media/dtsu5168_ct_master_4p.8e69990e.jpg";